export default __webpack_public_path__ + "static/media/logo-primaton.ef828131.svg";